import { ref, watch, computed, inject } from "vue"

export const useFieldsetState = (props) => {
  const formDisabled = inject("formDisabled", ref(false))
  const formReadonly = inject("formReadonly", ref(false))

  const disableComputed = computed(() => (props.formStateInheritanceDisabled ? props.disable : props.disable || formDisabled.value))
  const readonlyComputed = computed(() => (props.formStateInheritanceDisabled ? props.readonly : props.readonly || formReadonly.value))

  // A locked field (disabled or read-only) is not validated - notably it must not be flagged as required.
  // Calculated fields that are read-only on purpose but must still be validated opt out via `alwaysValidate`.
  const validationSkipped = computed(() => !props.alwaysValidate && (disableComputed.value || readonlyComputed.value))

  const isDirty = ref(false)

  watch(
    () => props.modelValue,
    () => {
      isDirty.value = true
    },
    { deep: true }
  )

  return { disableComputed, readonlyComputed, validationSkipped }
}
